@if (!isProduction && anyVisible()) {
  @if (!isMinimized()) {
    <div class="resize-handle-top" (mousedown)="startResize($event)" title="Drag to resize"></div>
  }
  <div class="dev-bar-inner">
    @if (service.networkVisible$ | async) {
      <div class="panel-slot">
        <app-dev-network-panel></app-dev-network-panel>
      </div>
    }
    @if (service.consoleVisible$ | async) {
      <div class="panel-slot">
        <app-dev-console-panel></app-dev-console-panel>
      </div>
    }
  </div>

  <button
    class="minimize-btn"
    (click)="service.toggleMinimized()"
    [title]="isMinimized() ? 'Expand dev bar' : 'Minimize dev bar'"
  >
    <mat-icon>{{ isMinimized() ? 'terminal' : 'unfold_less' }}</mat-icon>
  </button>
}
